import type { TKey } from '@/lib/i18n'

export type KVariant = 'add' | 'imp' | 'fix'
export type TagVariant = 'major' | 'new' | 'fix'

interface ChangelogItem {
	kVariant: KVariant
	textKey: TKey
}

interface ChangelogEntry {
	version: string
	tagVariant: TagVariant
	tagKey: TKey
	dateKey: TKey
	items: ChangelogItem[]
}

/** Hand-authored at release time. Newest first. */
export const CHANGELOG: ChangelogEntry[] = [
	{
		version: '1.4.0',
		tagVariant: 'major',
		tagKey: 'site:changelog.tag.major',
		dateKey: 'site:changelog.v1_4_0.date',
		items: [
			{ kVariant: 'add', textKey: 'site:changelog.v1_4_0.item_1' },
			{ kVariant: 'add', textKey: 'site:changelog.v1_4_0.item_2' },
			{ kVariant: 'add', textKey: 'site:changelog.v1_4_0.item_3' },
			{ kVariant: 'imp', textKey: 'site:changelog.v1_4_0.item_4' }
		]
	},
	{
		version: '1.3.0',
		tagVariant: 'new',
		tagKey: 'site:changelog.tag.new',
		dateKey: 'site:changelog.v1_3_0.date',
		items: [
			{ kVariant: 'add', textKey: 'site:changelog.v1_3_0.item_1' },
			{ kVariant: 'add', textKey: 'site:changelog.v1_3_0.item_2' },
			{ kVariant: 'imp', textKey: 'site:changelog.v1_3_0.item_3' }
		]
	},
	{
		version: '1.2.1',
		tagVariant: 'fix',
		tagKey: 'site:changelog.tag.fix',
		dateKey: 'site:changelog.v1_2_1.date',
		items: [
			{ kVariant: 'fix', textKey: 'site:changelog.v1_2_1.item_1' },
			{ kVariant: 'fix', textKey: 'site:changelog.v1_2_1.item_2' },
			{ kVariant: 'imp', textKey: 'site:changelog.v1_2_1.item_3' }
		]
	},
	{
		version: '1.2.0',
		tagVariant: 'new',
		tagKey: 'site:changelog.tag.new',
		dateKey: 'site:changelog.v1_2_0.date',
		items: [
			{ kVariant: 'add', textKey: 'site:changelog.v1_2_0.item_1' },
			{ kVariant: 'add', textKey: 'site:changelog.v1_2_0.item_2' },
			{ kVariant: 'imp', textKey: 'site:changelog.v1_2_0.item_3' }
		]
	},
	{
		version: '1.1.0',
		tagVariant: 'new',
		tagKey: 'site:changelog.tag.new',
		dateKey: 'site:changelog.v1_1_0.date',
		items: [
			{ kVariant: 'add', textKey: 'site:changelog.v1_1_0.item_1' },
			{ kVariant: 'imp', textKey: 'site:changelog.v1_1_0.item_2' }
		]
	},
	{
		version: '1.0.0',
		tagVariant: 'major',
		tagKey: 'site:changelog.tag.first_release',
		dateKey: 'site:changelog.v1_0_0.date',
		items: [
			{ kVariant: 'add', textKey: 'site:changelog.v1_0_0.item_1' },
			{ kVariant: 'add', textKey: 'site:changelog.v1_0_0.item_2' }
		]
	}
]

export const K_LABEL_KEY: Record<KVariant, TKey> = {
	add: 'site:changelog.k.add',
	imp: 'site:changelog.k.imp',
	fix: 'site:changelog.k.fix'
}
